
/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import type OnDemandVideosV1 from 'bundles/naptimejs/resources/onDemandVideos.v1';

function extractPreviewImagesFromOnDemandVideos(onDemandVideos: OnDemandVideosV1) {
  return Object.keys(onDemandVideos.sources.byResolution).reduce<Record<string, string>>((result, resolution) => {
    const sources = onDemandVideos.sources.byResolution[resolution];
    if (sources.previewImageUrl) {
      return {
        ...result,
        [resolution]: sources.previewImageUrl,
      };
    } else {
      return result;
    }
  }, {});
}

export default extractPreviewImagesFromOnDemandVideos;
